// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6-0A\\+ZeS8jihylPGY0MsLw\\=\\={padding-left:var(--xds-spacing-b);padding-left:var(--xds-spacing-b);width:max-content !important}", "",{"version":3,"sources":["webpack://./src/shared/components/PIETag/PIETag.module.scss"],"names":[],"mappings":"AAAA,8BACI,iCAAA,CACA,iCAAA,CACA,4BAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PIETag": "_6-0A+ZeS8jihylPGY0MsLw=="
};
export default ___CSS_LOADER_EXPORT___;
